import { useContext, useEffect } from "react";
import { IMAGE_TYPE } from "@utils/CONST";
import { GenerateContext, GenerateContextProvider } from "@view/page_v3/hooks/GenerateContext";
import UploadInput from "./index";
import styles from "./index.module.scss";

const DRAWER_PLACEHOLDER = "请描述你想要生成的图片效果，例如：生成一张高级时尚大片，重点展现服装的版型、面料质感与整体穿搭效果，模特气质简约高级，不抢服装风头，画面干净精致。";

const DrawerUploadInputValueSync = ({ imageUrl }) => {
    const { setMatchImages, setGenerateNum } = useContext(GenerateContext);

    useEffect(() => {
        if (!imageUrl) return;
        setMatchImages([{ url: imageUrl }]);
    }, [imageUrl, setMatchImages]);

    useEffect(() => {
        setGenerateNum(1);
    }, [setGenerateNum]);

    return null;
};

const DrawerUploadInput = ({ imageUrl = "", onGenerateRequest }) => {
    return (
        <GenerateContextProvider imageType={IMAGE_TYPE.CREATIVE_IMAGE_GEN}>
            <DrawerUploadInputValueSync imageUrl={imageUrl} />
            <UploadInput
                className={styles.DrawerInlineMode}
                disableUploadPopover
                placeholder={DRAWER_PLACEHOLDER}
                onGenerateRequest={onGenerateRequest}
            />
        </GenerateContextProvider>
    );
};

export default DrawerUploadInput;
